// Seltos carousel images
import seltosBackDesktop from "../../../assets/img/models/seltos/carousel/seltos-back-desktop.webp";
import seltosBackMobile from "../../../assets/img/models/seltos/carousel/seltos-back-mobile.webp";
import seltosFrontDesktop from "../../../assets/img/models/seltos/carousel/seltos-front-desktop.webp";
import seltosFrontMobile from "../../../assets/img/models/seltos/carousel/seltos-front-mobile.webp";
import seltosSideDesktop from "../../../assets/img/models/seltos/carousel/seltos-side-desktop.webp";
import seltosSideMobile from "../../../assets/img/models/seltos/carousel/seltos-side-mobile.webp";
// Seltos exterior images
import seltosExteriorPresencia from "../../../assets/img/models/seltos/exterior/seltos-exterior-presencia.webp";
import seltosExteriorProteccion from "../../../assets/img/models/seltos/exterior/seltos-exterior-proteccion.webp";
import seltosExteriorEstilo from "../../../assets/img/models/seltos/exterior/seltos-exterior-estilo.webp";
import seltosExteriorListo from "../../../assets/img/models/seltos/exterior/seltos-exterior-listo.webp";
import seltosExteriorDiseno from "../../../assets/img/models/seltos/exterior/seltos-exterior-diseno.webp";
// Seltos interior images
import seltosInteriorMandas from "../../../assets/img/models/seltos/interior/seltos-interior-mandas.webp";
import seltosInteriorConfort from "../../../assets/img/models/seltos/interior/seltos-interior-confort.webp";
import seltosInteriorEspacio from "../../../assets/img/models/seltos/interior/seltos-interior-espacio.webp";
import seltosInteriorConectado from "../../../assets/img/models/seltos/interior/seltos-interior-conectado.webp";
import seltosInteriorClima from "../../../assets/img/models/seltos/interior/seltos-interior-clima.webp";
// Seltos Attributes
import seltosAtributesDesktop from "../../../assets/img/models/seltos/atributes/seltos-atributes-desktop.webp";
import seltosAtributesMobile from "../../../assets/img/models/seltos/atributes/seltos-atributes-mobile.webp";
// Hero Videos
import heroVideoSeltosDesktop from "../../../assets/videos/seltos-hero-desktop.mp4";
import heroVideoSeltosMobile from "../../../assets/videos/seltos-hero-mobile.mp4";
// Seltos Etiqueta
import seltosEtiqueta from "../../../assets/fichas/Ficha técnica K3 Seltos LX.pdf";
// Seltos Fichas
import seltosFichas from "../../../assets/fichas/Ficha técnica K3 Seltos LX.pdf";

export const seltosImages = {
  carousel: {
    front: {
      desktop: seltosFrontDesktop,
      mobile: seltosFrontMobile,
    },
    back: {
      desktop: seltosBackDesktop,
      mobile: seltosBackMobile,
    },
    side: {
      desktop: seltosSideDesktop,
      mobile: seltosSideMobile,
    },
  },
  exterior: {
    presencia: {
      desktop: seltosExteriorPresencia,
      mobile: seltosExteriorPresencia,
    },
    proteccion: {
      desktop: seltosExteriorProteccion,
      mobile: seltosExteriorProteccion,
    },
    estilo: {
      desktop: seltosExteriorEstilo,
      mobile: seltosExteriorEstilo,
    },
    listo: {
      desktop: seltosExteriorListo,
      mobile: seltosExteriorListo,
    },
    diseno: {
      desktop: seltosExteriorDiseno,
      mobile: seltosExteriorDiseno,
    },
  },
  interior: {
    mandas: {
      desktop: seltosInteriorMandas,
      mobile: seltosInteriorMandas,
    },
    confort: {
      desktop: seltosInteriorConfort,
      mobile: seltosInteriorConfort,
    },
    espacio: {
      desktop: seltosInteriorEspacio,
      mobile: seltosInteriorEspacio,
    },
    conectado: {
      desktop: seltosInteriorConectado,
      mobile: seltosInteriorConectado,
    },
    clima: {
      desktop: seltosInteriorClima,
      mobile: seltosInteriorClima,
    },
  },
  attributes: {
    desktop: seltosAtributesDesktop,
    mobile: seltosAtributesMobile,
  },
  heroVideo: {
    desktop: heroVideoSeltosDesktop,
    mobile: heroVideoSeltosMobile,
  },
  etiqueta: seltosEtiqueta,
  fichas: seltosFichas,
};
